export default __webpack_public_path__ + "static/media/EXEMPLO 6.306e5034.jpg";